export default __webpack_public_path__ + "static/media/ETC-Base_Logo.8d5ff983.svg";